@if (layerTypeStore.asArray().length === 0) {
  <app-alert header="Keine Räume vorhanden" [canToggle]="false">
    Bevor Sie Geodaten importieren können, müssen Sie zuerst einen
    <a
      [routerLink]="[
        '/data-backend',
        {
          outlets: {
            overlay: ['neu', { outlets: { panel: ['raum', 'neu'] } }],
          },
        },
      ]"
      >Raum</a
    >
    anlegen.
  </app-alert>
} @else {
  <header>
    <app-header
      icon="fas fa-location-arrow"
      text="Auswahl treffen"></app-header>
    <div class="p-3 flex gap-3 p-card surface-ground align-items-center">
      <ng-container *ngIf="layerTypeStore.asArray() as layerTypes">
        <app-type-dropdown
          [mode]="'all'"
          [globalSelector]="true"
          [(selection)]="selectedType"></app-type-dropdown>
      </ng-container>
      <div class="">
        <app-layer-dropdown
          [disabled]="typeOfGeoData !== 'Point'"
          [(selection)]="selectedLayer"
          [globalSelector]="true"></app-layer-dropdown>
      </div>
      <!--<div class="ml-auto">
        <p-button
          [severity]="'primary'"
          [rounded]="true"
          icon="fas fa-download"
          label="Download GeoJson"
          (onClick)="downloadGeoJson()"></p-button>
      </div>-->
    </div>
  </header>

  <div class="grid" *ngIf="selectedType">
    <div class="col-6">
      <app-header
        icon="fas fa-cloud-upload"
        text="Import"
        sub="Laden Sie Ihre Geodaten hoch."></app-header>
      @if (canImport()) {
        <div class="flex gap-3">
          <div>
            <p-fileUpload
              mode="basic"
              chooseLabel="Datei hochladen"
              chooseIcon="pi pi-upload"
              name="uploadFile"
              (onBeforeUpload)="onBeforeSend($event)"
              [url]="geoDataService.getImportUrl()"
              [auto]="true"
              [accept]="acceptedFileExtensions"
            maxFileSize="10000000"
              (onUpload)="onUpload($event)" />
            <code>{{ acceptedFileExtensions }}</code>
          </div>

          <div class="ml-auto">
            <p-dropdown
              styleClass="w-16rem "
              [options]="supportedProjections"
              [(ngModel)]="selectedProjection"
              (ngModelChange)="updateProjection()"
              optionLabel="label"
              optionValue="value"
              placeholder="Projektion" />

            <div
              class="text-color-secondary text-xs flex align-items-center gap-2 pt-1 justify-content-end"
              pTooltip="Die Projektion dient der korrekten Darstellung der Geometrien im Atlas (Position und Verzerrung). Mithilfe der Kartenvorschau kann überprüft werden, welche Projektion verwendet werden muss. Wählen Sie im Drop-down-Menü die Projektion aus, mit der die Geometrien korrekt dargestellt werden."
              [showDelay]="300">
              <i class="fas fa-question-circle"></i> Hilfe
            </div>
          </div>
        </div>
        @if (!dataToImport) {
          <app-alert
            severity="info"
            [canToggle]="false"
            header="Geodaten importieren">
            <p>Die Datei muss einem bestimmten Schema entsprechen.</p>
            <p>
              Laden Sie Ihre Geodaten hoch. Nutzen Sie dafür die folgenden
              Dateiformate: .geojson, Shape-Datei (mit den einzelnen Dateien
              .shp, .dbf und .shx), als .zip, .kml, .gml, .xml, .osm, .pbf
            </p>
          </app-alert>
        }
      } @else {
        <app-alert
          header="Fehlende Rechte für den Geo-Import"
          [canToggle]="false">
          <p>
            Sie haben keine Berechtigung, Geodaten zu importieren. Bitte wenden
            Sie sich an den Administrator.
          </p>
        </app-alert>
      }

      <div *ngIf="uploadData" class="p-fluid">
        <p-divider></p-divider>
        <app-header
          icon="fas fa-arrows-turn-to-dots"
          text="Name und Schlüssel zuordnen"
          sub="Legen Sie fest, welche Felder aus den importierten Geodaten den
            Namen und den Schlüssel der Teilräume enthalten. Wählen Sie die
            passenden Felder im Dropdown-Menü aus."></app-header>

        <div
          class="grid"
          *ngFor="
            let geoProperty of typeOfGeoData === 'Polygon'
              ? geoProperties
              : poiGeoProperties;
            let i = index
          ">
          <app-form-field-wrapper
            [label]="geoProperty.label"
            [name]="geoProperty.key"
            [colSize]="5">
            <p-dropdown
              [options]="importFeatureProperties"
              [required]="geoProperty.required"
              [(ngModel)]="mappedProperties[geoProperty.key]"
              (onChange)="updateModel(geoProperty.key, $event)">
              <ng-template let-property pTemplate="item">
                <div>{{ property }}</div>
                <div class="text-color-secondary text-sm">
                  {{ importFeatureValues[property] | slice: 0 : 35 }} ...
                </div>
              </ng-template>
            </p-dropdown>
          </app-form-field-wrapper>
          <div class="p-2 col-7">
            <div class="mt-5 mb-3 px-3 pt-3 pb-2 gap-3 p-card surface-ground">
              @if (mappedProperties[geoProperty.key]) {
                <i>
                  {{
                    importFeatureValues[mappedProperties[geoProperty.key]]
                      | join
                      | slice: 0 : 50
                  }}
                  ...
                </i>
              } @else {
                <i class="text-color-secondary">Bitte auswählen ...</i>
              }
            </div>
          </div>
        </div>
        <footer class="flex gap-3">
          <p-button
            icon="fas fa-xmark-circle"
            severity="secondary"
            type="button"
            [rounded]="true"
            [outlined]="true"
            label="abbrechen"
            (onClick)="cancel()"></p-button>
        </footer>
        <p-divider></p-divider>
      </div>
      @if (globalStore.getFeatureCollectionFromSelection() || dataToImport) {
        <div style="height: 20rem; width: 100%">
          <div class="flex align-items-center gap-3">
            <app-header
              icon="fas fa-earth-europe"
              [text]="dataToImport ? 'Vorschau' : 'Vorschau'"></app-header>

            @if (dataToImport) {
              <p-dropdown
                class="ml-auto"
                styleClass="w-16rem "
                [options]="supportedProjections"
                [(ngModel)]="selectedProjection"
                (ngModelChange)="updateProjection()"
                optionLabel="label"
                optionValue="value"
                placeholder="Projektion" />
            }
          </div>
          <div class="h-30rem">
            <app-basic-map
              [dataLayerType]="selectedType"
              [geoJsonData]="
                dataToImport || geoDataStore.geoJsonFromSelection()
              "></app-basic-map>
          </div>
        </div>
      } @else if (globalStore.selectedGeoData() && !dataToImport) {
        <app-alert
          severity="warning"
          [canToggle]="false"
          header="Geodaten noch nicht vorhanden">
          <p>
            Für diesen Raum wurden über den Datenimport für die Teilräume
            Platzhalter ohne Geometrien erzeugt.
          </p>
          <p>
            Achten Sie darauf, dass Name und Schlüssel der Geodaten mit den
            bereits hochgeladenen Daten übereinstimmen.
          </p>
        </app-alert>
      }
    </div>
    <div class="col-6">
      <app-header
        icon="fas fa-cloud-download"
        text="Export"
        sub="Laden Sie Ihre Geodaten als GeoJSON herunter."></app-header>

      @if (canExport()) {
        <p-button
          [severity]="'primary'"
          [rounded]="true"
          icon="fas fa-download"
          label="exportieren"
          (onClick)="downloadGeoJson()"></p-button>
        <p-divider />
      } @else {
        <app-alert
          header="Fehlende Rechte für den Geo-Export"
          [canToggle]="false">
          <p>
            Sie haben keine Berechtigung, Geodaten zu exportieren. Bitte wenden
            Sie sich an den Administrator.
          </p>
        </app-alert>
      }

      <!--
      @if (
        dataToImport && (!mappedProperties['key'] || !mappedProperties['name'])
      ) {
        <app-alert header="Name und Schlüssel zuordnen" [canToggle]="false">
          <p>
            Legen Sie fest, welche Felder aus den importierten Geodaten den
            Namen und den Schlüssel der Teilräume enthalten. Wählen Sie die
            passenden Felder im Dropdown-Menü aus.
          </p>
        </app-alert>
      }-->

      @if (geoDataStore.initialized()) {
        <app-feature-form
          #importFeatureForm
          (submitted)="clear()"
          (cancelled)="cancel()"
          [type]="typeOfGeoData"
          [selectedLayer]="selectedLayer"
          [inputFeatures]="
            dataToImport && mappedProperties['key'] && mappedProperties['name']
              ? dataToImport.features
              : undefined
          "></app-feature-form>
      }
    </div>
  </div>
}
